import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Shop() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16" data-testid="shop-page">
      <div className="text-xs uppercase tracking-[0.28em] text-[#C93B3B]">Shop</div>
      <h1 className="font-serif text-5xl lg:text-6xl mt-4 text-[#F7ECEB]">Objects for the ritual.</h1>

      <div className="mt-12 tt-card p-10 lg:p-16 max-w-3xl" data-testid="shop-coming-soon">
        <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#E58B5E]">
          <Sparkles className="w-4 h-4" /> Coming soon
        </div>
        <h2 className="font-serif text-3xl mt-4 text-[#F7ECEB]">The Touche collection is being curated.</h2>
        <p className="text-[#A89896] mt-5 leading-relaxed">
          Weighted blankets, warm aromatherapy, and small-batch body oils — every piece hand-selected to
          carry the calm of a session home with you. The shop opens soon.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/practitioners" className="btn-primary text-sm" data-testid="shop-browse-practitioners">Book a session</Link>
          <Link to="/membership" className="btn-secondary text-sm" data-testid="shop-view-membership">View membership</Link>
        </div>
      </div>
    </div>
  );
}
